import PropTypes from 'prop-types';
import { Box, Grid, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ADJUST_TO_ALLOWED_LIMIT } from '../../../constants';

const CustomInfoBanner = ({ bannerData }) => {
  const {
    backgroundColor,
    borderColor,
    iconColor,
    bannerText1,
    bannerText2,
    Icon,
    linkData,
    handleLinkClick,
    linkDisabledCondition,
  } = bannerData;
  const { t } = useTranslation();
  return (
    <Grid container>
      <Grid
        size={{ sm: 12, md: 12, lg: 12 }}
        sx={{
          backgroundColor,
          padding: '15px',
          border: `1px solid ${borderColor}`,
          borderRadius: '6px',
        }}
      >
        <Box display="flex">
          <Box>{Icon}</Box>
          <Box marginLeft="12px">
            <Typography component="h5" variant="h5" sx={{ fontWeight: 700 }}>
              {' '}
              {bannerText1}
            </Typography>
            {bannerText2 && (
              <Typography component="p" variant="subtitle2" pt={1} pb={1.5}>
                {t(bannerText2, { defaultValue: bannerText2 })}
              </Typography>
            )}
            {linkData && !linkDisabledCondition && (
              <Box my={1}>
                <Link
                  type="button"
                  sx={{
                    fontSize: '14px',
                    fontWeight: 700,
                    cursor: 'pointer',
                    padding: '10px 0',
                  }}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handleLinkClick && handleLinkClick(e);
                  }}
                  onClick={() => {
                    handleLinkClick && handleLinkClick();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                      handleLinkClick && handleLinkClick(e);
                    }
                  }}
                  color="danger"
                  variant="danger"
                  // ref={fileInput}
                >
                  {t(ADJUST_TO_ALLOWED_LIMIT, { defaultValue: ADJUST_TO_ALLOWED_LIMIT })}
                </Link>
              </Box>
            )}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default CustomInfoBanner;
CustomInfoBanner.propTypes = {
  bannerData: PropTypes.object,
  linkDisabledCondition: PropTypes.bool,
};
